import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import BookingModal from "./BookingModal";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <nav className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-slate-100 shadow-sm transition-all duration-200" data-testid="navbar">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="flex justify-between h-20 items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2.5 group" data-testid="navbar-logo-link">
              <div className="w-10 h-10 rounded bg-slate-900 flex items-center justify-center text-white font-bold text-lg border border-slate-800 shadow-inner group-hover:bg-emerald-600 transition-colors duration-200">
                P
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-slate-900 tracking-tight text-lg leading-none">
                  PRECISION
                </span>
                <span className="text-[11px] text-slate-500 font-semibold tracking-[0.22em] leading-none mt-1">
                  HOME LEADS <span className="text-emerald-600">LLC</span>
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-home">Home</Link>
              <Link to="/about" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-about">About</Link>
              <Link to="/how-it-works" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-how-it-works">How It Works</Link>
              <Link to="/industries" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-industries">Industries</Link>
              <Link to="/faq" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-faq">FAQ</Link>
              <Link to="/contact" className="text-slate-600 hover:text-slate-900 font-medium text-[15px] transition-colors" data-testid="nav-link-contact">Contact</Link>
              <button 
                onClick={() => setShowModal(true)}
                className="inline-flex items-center justify-center px-5 py-2.5 rounded bg-emerald-600 hover:bg-emerald-700 text-white font-medium text-[15px] shadow-sm hover:shadow transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2"
                data-testid="nav-book-call-button"
              >
                Book a Call
              </button>
            </div>

            {/* Mobile Hamburger Toggle */}
            <div className="flex md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-slate-600 hover:text-slate-900 p-2 focus:outline-none"
                data-testid="mobile-menu-toggle"
                aria-label="Toggle menu"
              >
                {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation Drawer */}
        {isOpen && (
          <div className="md:hidden bg-white border-b border-slate-100 px-6 pt-2 pb-6 space-y-3 shadow-lg" data-testid="mobile-menu">
            <Link 
              to="/" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-home"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-about"
            >
              About
            </Link>
            <Link 
              to="/how-it-works" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-how-it-works"
            >
              How It Works
            </Link>
            <Link 
              to="/industries" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-industries"
            >
              Industries
            </Link>
            <Link 
              to="/faq" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-faq"
            >
              FAQ
            </Link>
            <Link 
              to="/contact" 
              onClick={() => setIsOpen(false)} 
              className="block py-2 text-slate-600 hover:text-slate-900 font-medium"
              data-testid="mobile-nav-link-contact"
            >
              Contact
            </Link>
            <button 
              onClick={() => { setIsOpen(false); setShowModal(true); }}
              className="w-full inline-flex items-center justify-center px-5 py-3 rounded bg-emerald-600 hover:bg-emerald-700 text-white font-medium text-center shadow-sm transition-colors"
              data-testid="mobile-nav-book-call-button"
            >
              Book a Call
            </button>
          </div>
        )}
      </nav>

      <BookingModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
